import _ from 'lodash';
import { lsApiService, lsStorageService } from 'ls-vue-common';
// eslint-disable-next-line import/no-cycle
import lsOrderService from '@/services/order/order.service';
import { savedOrderModuleConstants } from '@/services/storage/storage-key.constants';
import { DealBannerConstants } from '@/constants';
import {
    DEAL__MUTATE_LOADING_STATUS,
    DEAL__MUTATE_VALID_DEAL,
    DEAL__MUTATE_BANNER,
    DEAL__ADD_DEAL,
    DEAL__UPDATE_BANNER,
    ORDER__UPDATE_ORDER,
} from '../types';

const dealModule = {
    state: {
        loadingStatus: {
            isLoading: false,
            isUpdating: false,
        },
        validDeal: {},
        banner: {
            version: null,
            minutes: 0,
        },
    },

    mutations: {
        [DEAL__MUTATE_LOADING_STATUS](state, payload) {
            _.assign(state.loadingStatus, payload);
        },
        [DEAL__MUTATE_VALID_DEAL](state, payload) {
            state.validDeal = payload;
        },
        [DEAL__MUTATE_BANNER](state, payload) {
            _.assign(state.banner, payload);
        },
    },

    actions: {
        [DEAL__ADD_DEAL]({ commit, dispatch, rootState }, { deal }) {
            commit(DEAL__MUTATE_LOADING_STATUS, { isUpdating: true });

            const { order } = rootState;

            const previousDeal = order.deal;
            const addDeal = lsOrderService.addDeal({ order_id: order.order_id, deal });

            let dealInfo = Promise.resolve();
            // if exposure is equal to CDTv2, we need to make a /deals call to render copy properly
            if (order.exposure === DealBannerConstants.v2) {
                dealInfo = lsApiService.request({
                    route: `/deals/${deal}`,
                });
            }

            return Promise.all([addDeal, dealInfo])
                .then((response) => {
                    // if /deals call wasn't made, compose a validDeal anyways with deal_id
                    commit(
                        DEAL__MUTATE_VALID_DEAL,
                        _.get(response[1], 'data', {
                            deal_id: deal,
                        })
                    );

                    dispatch(ORDER__UPDATE_ORDER, {
                        cart: response[0].data.cart,
                        deal,
                    });

                    // if deal code is valid, but they've changed it - hide the banner
                    if (deal !== previousDeal) {
                        dispatch(DEAL__UPDATE_BANNER, {});
                    } else if (order.exposure === DealBannerConstants.v2) {
                        // otherwise if exposure is equal to CDTv2, show the banner
                        dispatch(DEAL__UPDATE_BANNER, {
                            minutes: DealBannerConstants.minutes,
                            version: 'v2',
                        });
                    }
                })
                .catch(() => {
                    commit(DEAL__MUTATE_VALID_DEAL, {});
                    dispatch(DEAL__UPDATE_BANNER, {});
                    lsStorageService.remove(savedOrderModuleConstants.DEAL);
                })
                .finally(() => {
                    commit(DEAL__MUTATE_LOADING_STATUS, { isUpdating: false });
                });
        },
        [DEAL__UPDATE_BANNER]({ commit }, { minutes = 0, version = null }) {
            commit(DEAL__MUTATE_BANNER, { minutes, version });
        },
    },
};

export default dealModule;
